/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Common_Minutes_AgoInputs */

const en_common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}m ago`)
};

const de_common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vor ${i?.count} Min.`)
};

const fr_common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il y a ${i?.count} min`)
};

const es_common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hace ${i?.count} min`)
};

const it_common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}m fa`)
};

const nl_common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}m geleden`)
};

const pl_common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}m temu`)
};

const fi_common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}m sitten`)
};

const da_common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}m siden`)
};

const sv_common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}m sedan`)
};

/**
* | output |
* | --- |
* | "{count}m ago" |
*
* @param {Common_Minutes_AgoInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_minutes_ago = /** @type {((inputs: Common_Minutes_AgoInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Minutes_AgoInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_minutes_ago(inputs)
	if (locale === "fr") return fr_common_minutes_ago(inputs)
	if (locale === "es") return es_common_minutes_ago(inputs)
	if (locale === "it") return it_common_minutes_ago(inputs)
	if (locale === "nl") return nl_common_minutes_ago(inputs)
	if (locale === "pl") return pl_common_minutes_ago(inputs)
	if (locale === "fi") return fi_common_minutes_ago(inputs)
	if (locale === "da") return da_common_minutes_ago(inputs)
	if (locale === "sv") return sv_common_minutes_ago(inputs)
	return en_common_minutes_ago(inputs)
});